<!-- Etapa: Dados do Investidor (PF) -->
<ng-container *ngIf="etapa === 'dados' && typeForm === 'PF'">
  <div class="row col-12">
    <form class=" col-12 p-5" [formGroup]="formInvestidorPF">
      <fieldset>
        <h3 class="form-title text-center">1 - Dados do Investidor</h3>
        <div class="custom-box-alert mt-5 mb-5">
          <i class="fas fa-info-circle"></i>
          <div>
            <p>O Cadastro de Pessoa Física para Garantia Ordinária deve ser realizado através do APP FGC.</p>
            <p>Para garantir que seus dados sejam salvos corretamente, desative as extensões ou plugins do seu navegador. <strong (click)="openModalInfo()">Saiba mais.</strong></p>
          </div>
        </div>
          <div class="form-row mt-4">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">CPF Investidor *</label>
              <input mask="000.000.000-00" formControlName="documentoIdentificador" autocomplete="off" placeholder="Ex: 000.000.000-00" name="documentoIdentificador" type="text" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="documentoIdentificadorPF.invalid && (documentoIdentificadorPF.dirty || documentoIdentificadorPF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Nome Investidor *</label>
              <input maxlength="150" placeholder="Digite seu nome" formControlName="nome" autocomplete="off" name="nomeCompleto" type="text" class="form-control custom-input">
            <span class="error-form ml-2" *ngIf="nomePF.invalid && (nomePF.dirty || nomePF.touched)">Campo obrigatório.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Email *</label>
              <input formControlName="email" autocomplete="new-email" placeholder="example@example.com" name="email" type="email" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="emailPF.invalid && (emailPF.dirty || emailPF.touched)">Digite um email válido.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Confirme o Email *</label>
              <input formControlName="confirmaEmail" autocomplete="new-email" placeholder="example@example.com" name="emailConfirmar" type="email" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="confirmaEmailPF.invalid && (confirmaEmailPF.dirty || confirmaEmailPF.touched)">A confirmação deve ser igual ao e-mail informado.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-4">
              <label  class="form-label">DDI *</label>
              <select formControlName="codigoDdi" autocomplete="off" name="ddi" type="text" class="form-control custom-input">
                <option selected value="">Selecione uma das opções</option>
                <option value="+55">Brasil</option>
                <option *ngFor="let opt of tableDdi" value="{{opt.code}}">{{opt.name}}</option>
              </select>
            <span class="error-form ml-2" *ngIf="ddiPF.invalid && (ddiPF.dirty || ddiPF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-4">
              <label  class="form-label">Celular <i mdbTooltip='Este campo só é obrigatório caso o campo "Telefone" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
              <input formControlName="celular" autocomplete="off" [mask]="maskTelefone(2)" name="celular" type="text" class="form-control custom-input" placeholder="(00) 00000-0000">
              <span class="error-form ml-2" *ngIf="celularPF.errors?.minlength">Celular deve ter 11 dígitos.</span>
              <span class="error-form ml-2" *ngIf="celularPF.invalid && (celularPF.dirty || celularPF.touched)">Informe um celular válido.</span>
            </div>
            <div class="form-group col-sm-12 col-md-4">
              <label class="form-label">Telefone <i mdbTooltip='Este campo só é obrigatório caso o campo "Celular" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
              <input  formControlName="telefone" autocomplete="off" [mask]="maskTelefone(1)" name="telefone" type="text" class="form-control custom-input" placeholder="(00) 0000-0000">
              <span class="error-form ml-2" *ngIf="telefonePF.errors?.minlength">Telefone deve ter 10 dígitos.</span>
              <span class="error-form ml-2" *ngIf="telefonePF.invalid && (telefonePF.dirty || telefonePF.touched)">Informe um telefone válido.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-4">
              <label class="form-label">Data de Nascimento *</label>
              <input data-testid="data-nascimento-pf" type="date" class="form-control custom-input" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
            </div>
            <div class="form-group mb-0 col-sm-12 col-md-8 d-flex align-items-center justify-content-center">
              <label class="form-label mb-0">
                <mdb-checkbox data-testid="checkbox-incapaz" name="checked" formControlName="incapaz" class="form-label"><u>Incapaz? Necessita de assistência? Auxílio?</u></mdb-checkbox>
              </label>
            </div>
          </div>
          <div *ngIf="!maiorDeIdade || incapazPF.value" class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label  class="form-label">Documento Identificador do Responsável *</label>
              <input data-testid="documento-responsavel" formControlName="documentoResponsavel" autocomplete="off" mask="000.000.000-00" name="Documento Responsavel" type="text" class="form-control custom-input" placeholder="Ex: 000.000.000-00">
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label  class="form-label">Nome do Responsável *</label>
              <input data-testid="nome-responsavel" formControlName="nomeResponsavel" autocomplete="off" name="Nome Responsavel" type="text" class="form-control custom-input" placeholder="Digite o nome do responsável">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Senha *</label>
                <div class="password-container">
                    <input data-testid="senha-pf" [type]="mostrarSenha ? 'text' : 'password'" formControlName="senha" autocomplete="off" placeholder="Ex: ************" class="form-control custom-input" (input)="checkSenha()"/>
                      <i class="fas" [ngClass]="mostrarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenha = !mostrarSenha"></i>
                </div>
                <span class="error-form ml-2" *ngIf="senhaPF.invalid && senhaPF.errors?.required && senhaPF.touched">Campo obrigatório.</span>
                <span class="error-form ml-2" *ngIf="senhaPF.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Confirme sua senha *</label>
                <div class="password-container">
                  <input data-testid="confirma-senha-pf" [type]="mostrarConfirmarSenha? 'text' : 'password'" formControlName="confirmaSenha" autocomplete="off" class="form-control custom-input" placeholder="Ex: ************" />
                  <i class="fas" [ngClass]="mostrarConfirmarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarConfirmarSenha = !mostrarConfirmarSenha"></i>
                </div>
                <span class="error-form ml-2" *ngIf="confirmarSenhaPF.touched && confirmarSenhaPF.errors?.senhasDiferentes && !confirmarSenhaPF.errors?.required">A confirmação deve ser igual à senha informada.</span>
              </div>
            </div>
          </div>
          <div class="content col-md-12 mt-1">
            <p>Sua senha deve conter:</p>
            <ul class="requirement-list col-md-12 mt-1">
              <li [ngClass]="{ 'text-success': checarSenha.minLength, 'text-danger': !checarSenha.minLength }">
                <i class="fa" [ngClass]="checarSenha.minLength ? 'fa-check' : 'fa-times'"></i>
                <span> No mínimo 8 caracteres</span>
              </li>
              <li [ngClass]="{ 'text-success': checarSenha.uppercase, 'text-danger': !checarSenha.uppercase }">
                <i class="fa" [ngClass]="checarSenha.uppercase ? 'fa-check' : 'fa-times'"></i>
                <span> 1 letra maiúscula</span>
              </li>
              <li [ngClass]="{ 'text-success': checarSenha.specialCharacter, 'text-danger': !checarSenha.specialCharacter }">
                <i class="fa" [ngClass]="checarSenha.specialCharacter ? 'fa-check' : 'fa-times'"></i>
                <span> 1 caractere especial (!,@,#,$)</span>
              </li>
              <li [ngClass]="{ 'text-success': checarSenha.number, 'text-danger': !checarSenha.number }">
                <i class="fa" [ngClass]="checarSenha.number ? 'fa-check' : 'fa-times'"></i>
                <span> 1 número</span>
              </li>
            </ul>
          </div>
          <div class="form-row mt-5">
            <mdb-checkbox data-testid="checkbox-politica-privacidade" name="checked" formControlName="termoAceite" class="form-label">Li e estou de acordo com a <u (click)="termoPoliticaPrivacidade()">Política de privacidade</u>. *</mdb-checkbox>
            <span class="error-form ml-2" *ngIf="termPF.invalid && (termPF.dirty || termPF.touched)">Concorde com o termo de aceite.</span>
          </div>
      </fieldset>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button data-testid="botao-proximo" (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Próximo</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Dados do Solicitante (PJ / Fundo de Investimento) -->
<ng-container *ngIf="etapa === 'dados' && (typeForm === 'PJ' || typeForm === 'FUNDO_INVESTIMENTO')">
  <div class="row col-12">
    <form class="col-12 p-5" [formGroup]="formInvestidorPJ" autocomplete="off">
      <h3 class="form-title text-center">1 - Dados do Solicitante</h3>
      <div class="custom-box-alert mt-5 mb-5">
        <i class="fas fa-info-circle"></i>
        <p>
          O solicitante será o responsável pelo cadastro inicial da solicitação de garantia. O Representante Legal da empresa será cadastrado na próxima etapa.<br>
          Para garantir que seus dados sejam salvos corretamente, desative as extensões ou plugins do seu navegador. <strong (click)="openModalInfo()">Saiba mais.</strong>
        </p>
      </div>
      <div class="form-row mt-3">
        <div class="form-group col-sm-12 col-md-6">
          <label class="form-label">Nome completo*</label>
          <input data-testid="nome-pj" autocomplete="off" formControlName="nome" name='nome' type="text" class="form-control custom-input" placeholder="Digite seu nome completo">
          <span class="error-form ml-2" *ngIf="nomePJ.invalid && (nomePJ.dirty || nomePJ.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label">CPF *</label>
          <input data-testid="cpf-pj" autocomplete="off" formControlName="documentoIdentificador" name='documentoIdentificador' mask="000.000.000-00" type="text" class="form-control custom-input" placeholder="000.000.000-00">
          <span class="error-form ml-2" *ngIf="documentoIdentificadorPJ.invalid && (documentoIdentificadorPJ.dirty || documentoIdentificadorPJ.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label">Data de Nascimento *</label>
          <input data-testid="data-nascimento-pj" data-testid="data-nascimento-pj" type="date" class="form-control custom-input" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="col-6">
          <div class="form-outline">
            <label class="form-label" for="form1">E-mail *</label>
            <input data-testid="email-pj" autocomplete="new-username" type="email" formControlName="email" placeholder="example@example.com" class="form-control custom-input form-icon-trailing" />
            <span class="error-form ml-2" *ngIf="emailPJ.invalid && (emailPJ.dirty || emailPJ.touched)">Digite um email válido.</span>
          </div>
        </div>
        <div class="col-6">
          <div class="form-outline">
            <label class="form-label" for="form1">Confirme seu e-mail *</label>
            <input data-testid="confirma-email-pj" autocomplete="new-username" type="email" formControlName="confirmaEmail" placeholder="example@example.com" class="form-control custom-input form-icon-trailing" />
              <span class="error-form ml-2" *ngIf="confirmaEmailPJ.invalid && (confirmaEmailPJ.dirty || confirmaEmailPJ.touched)">A confirmação deve ser igual ao e-mail informado.</span>
          </div>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="col-md-6">
          <div class="form-outline">
            <label class="form-label">Senha *</label>
            <div class="password-container">
                <input data-testid="senha-pj" autocomplete="new-password" [type]="mostrarSenha? 'text' : 'password'" formControlName="senha" placeholder="Digite sua senha" class="form-control custom-input" (input)="checkSenha()" />
                <i class="fas" [ngClass]="mostrarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenha = !mostrarSenha"></i>
            </div>
            <span class="error-form ml-2" *ngIf="senhaPJ.invalid && senhaPJ.errors?.required && senhaPJ.touched">Campo obrigatório.</span>
            <span class="error-form ml-2" *ngIf="senhaPJ.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-outline">
            <label class="form-label">Confirme sua senha *</label>
            <div class="password-container">
              <input data-testid="confirma-senha-pj" autocomplete="new-password" [type]="mostrarConfirmarSenha? 'text' : 'password'" formControlName="confirmaSenha" class="form-control custom-input" placeholder="Digite novamente a sua senha" />
              <i class="fas" [ngClass]="mostrarConfirmarSenha? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarConfirmarSenha = !mostrarConfirmarSenha"></i>
            </div>
            <span class="error-form ml-2" *ngIf="confirmarSenhaPJ.touched && confirmarSenhaPJ.errors?.senhasDiferentes && !confirmarSenhaPJ.errors?.required">A confirmação deve ser igual à senha informada.</span>
          </div>
        </div>
        <div class="content col-md-12 mt-1">
          <p>Sua senha deve conter:</p>
          <ul class="requirement-list col-md-12 mt-1">
            <li [ngClass]="{ 'text-success': checarSenha.minLength, 'text-danger': !checarSenha.minLength }">
              <i class="fa" [ngClass]="checarSenha.minLength ? 'fa-check' : 'fa-times'"></i>
              <span> No mínimo 8 caracteres</span>
            </li>
            <li [ngClass]="{ 'text-success': checarSenha.uppercase, 'text-danger': !checarSenha.uppercase }">
              <i class="fa" [ngClass]="checarSenha.uppercase ? 'fa-check' : 'fa-times'"></i>
              <span> 1 letra maiúscula</span>
            </li>
            <li [ngClass]="{ 'text-success': checarSenha.specialCharacter, 'text-danger': !checarSenha.specialCharacter }">
              <i class="fa" [ngClass]="checarSenha.specialCharacter ? 'fa-check' : 'fa-times'"></i>
              <span> 1 caractere especial (!,@,#,$)</span>
            </li>
            <li [ngClass]="{ 'text-success': checarSenha.number, 'text-danger': !checarSenha.number }">
              <i class="fa" [ngClass]="checarSenha.number ? 'fa-check' : 'fa-times'"></i>
              <span> 1 número</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="form-row mt-5">
        <div class="col-md">
          <mdb-checkbox data-testid="checkbox-politica-privacidade" name="checked" formControlName="termoAceite">
            <span class="texto-politica"> Li e estou de acordo com a </span>
            <span class="link-politica" (click)="termoPoliticaPrivacidade()">Política de privacidade</span>.<span class="texto-politica">*</span>
          </mdb-checkbox>
          <span class="error-form ml-2" *ngIf="termPJ.invalid && termPJ.errors?.required  && senhaPJ.touched">Concorde com o termo de aceite.</span>
        </div>
      </div>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button data-testid="proxima-etapa-email" (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Continuar</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Dados do Responsável (Entidade) -->
<ng-container *ngIf="etapa === 'dados' && typeForm === 'ENTIDADE'">
  <div class="row col-12">
    <div class="col-12 justify-content-center align-items-center">
      <h3 class="form-title text-center">1 - Dados do Responsável</h3>
    </div>

    <form class="col-12 p-5" [formGroup]="formResponsavelEntidade">
      <div class="custom-box-alert mt-2 mb-4 justify-content-center align-items-center">
        <i class="fas fa-info-circle"></i>
        <p>
          Para garantir que seus dados sejam salvos corretamente, desative as extensões ou plugins do seu navegador. <strong (click)="openModalInfo()">Saiba mais.</strong>
        </p>
      </div>
      <fieldset>
          <div class="form-row mt-4">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Nome *</label>
              <input formControlName="nomeContato" autocomplete="off" placeholder="Digite o nome do responsável para contatos" name="nomeContato" type="text" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="nomeContatoResponsavelEntidade.invalid && (nomeContatoResponsavelEntidade.dirty || nomeContatoResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-3">
              <label class="form-label">CPF *</label>
              <input mask="000.000.000-00" formControlName="documentoIdentificador" autocomplete="off" placeholder="Ex: 000.000.000-00" name="CPF" type="text" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="documentoIdentificadorResponsavelEntidade.invalid && (documentoIdentificadorResponsavelEntidade.dirty || documentoIdentificadorResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-3">
              <label class="form-label">Data de Nascimento <b class="text-danger">*</b></label>
              <input type="date" class="form-control" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Email *</label>
              <input formControlName="email" autocomplete="off" placeholder="example@example.com" name="email" type="email" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="emailResponsavelEntidade.invalid && (emailResponsavelEntidade.dirty || emailResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Confirme o Email *</label>
              <input formControlName="confirmaEmail" autocomplete="off" placeholder="example@example.com" name="emailConfirmar" type="email" class="form-control custom-input">
            <span class="error-form ml-2" *ngIf="confirmaEmailResponsavelEntidade.invalid && (confirmaEmailResponsavelEntidade.dirty || confirmaEmailResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Senha *</label>
                <div class="input-group">
                    <input [type]="showPassword? 'text' : 'password'" formControlName="senha" autocomplete="off" placeholder="Ex: ************" class="form-control custom-input" (input)="checkSenha()"/>
                </div>
                <span class="error-form ml-2" *ngIf="senhaResponsavelEntidade.invalid && senhaResponsavelEntidade.errors?.required && senhaResponsavelEntidade.touched">Campo obrigatório.</span>
                <span class="error-form ml-2" *ngIf="senhaResponsavelEntidade.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Confirme sua senha *</label>
                <div class="input-group">
                  <input [type]="showPassword? 'text' : 'password'" formControlName="confirmaSenha" autocomplete="off" class="form-control custom-input" placeholder="Ex: ************" />
                  <div class="input-group-text ml-1" style="cursor: pointer">
                    <i [ngClass]="showPassword? 'far fa-eye-slash' : 'fas far fa-eye'" (click)="showPassword = !showPassword"></i>
                  </div>
                </div>
                <span class="error-form ml-2" *ngIf="confirmarSenhaResponsavelEntidade.invalid && confirmarSenhaResponsavelEntidade.errors?.required && confirmarSenhaResponsavelEntidade.touched">Campo obrigatório.</span>
                <span class="error-form ml-2" *ngIf="confirmarSenhaResponsavelEntidade.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
              </div>
            </div>
            <div class="content col-md-12 mt-1">
              <p>Sua senha deve conter:</p>
              <ul class="requirement-list col-md-12 mt-1">
                <li [ngClass]="{ 'text-success': checarSenha.minLength, 'text-danger': !checarSenha.minLength }">
                  <i class="fa" [ngClass]="checarSenha.minLength ? 'fa-check' : 'fa-times'"></i>
                  <span> No mínimo 8 caracteres</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.uppercase, 'text-danger': !checarSenha.uppercase }">
                  <i class="fa" [ngClass]="checarSenha.uppercase ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 letra maiúscula</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.specialCharacter, 'text-danger': !checarSenha.specialCharacter }">
                  <i class="fa" [ngClass]="checarSenha.specialCharacter ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 caractere especial (!,@,#,$)</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.number, 'text-danger': !checarSenha.number }">
                  <i class="fa" [ngClass]="checarSenha.number ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 número</span>
                </li>
              </ul>
            </div>
          </div>
        <div class="form-row  mt-5">
          <mdb-checkbox name="checked" formControlName="termoAceite">
            <span class="texto-politica"> Li e estou de acordo com a </span>
            <span class="link-politica" (click)="termoPoliticaPrivacidade()">Política de privacidade</span>.<b class="text-danger">*</b>
          </mdb-checkbox>
          <span class="error-form ml-2" *ngIf="termResponsavelEntidade.invalid && termResponsavelEntidade.errors?.required  && termResponsavelEntidade.touched">Concorde com o termo de aceite.</span>
        </div>
      </fieldset>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Continuar</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Validar Email (compartilhada entre PF, PJ/Fundo e Entidade) -->
<ng-container *ngIf="etapa === 'email'">
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <form class="col-12 p-5" [formGroup]="formToken">
        <h3 class="form-title text-center">2 - Validar e-mail</h3>
        <div class="form-row mt-5 d-flex justify-content-center">
          <div class="icon-email">
            <span class="material-icons-outlined">
              mail
            </span>
          </div>
        </div>
        <div class="form-row">
          <h3 class="subtitle-form text-center col-12">Enviamos um código de verificação para</h3>
        </div>
        <div class="form-row mt-2">
          <div class="col-md">
            <h3 class="title-email">
              <p><b>{{ emailUsuario }}</b></p>
            </h3>
          </div>
        </div>
        <div class="form-row mt-4 mb-4">
          <div class="col-md">
            <h3 class="info-email">
              Digite o código de 6 dígitos abaixo:
            </h3>
          </div>
        </div>
          <div>
            <app-token-input
            [formControl]="token"
            [status]="tokenStatus"
            [resendSeconds]="60"
            (resend)="reenviarToken.emit()"
            >
            </app-token-input>
          </div>
        <div class="form-row mt-5 d-flex justify-content-center">
          <div class="col-md-4 d-flex justify-content-center">
            <button data-testid="botao-voltar" (click)="voltarToken.emit()" type="button" class="btn-voltar">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>
          </div>
          <div class="col-md-4 d-flex justify-content-center">
            <button data-testid="proxima-etapa" (click)="continuarToken.emit()" class="btn">
              Verificar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
